<div class="loader_session" *ngIf='loaderdata'>
  <div class="loader-4"><span></span>
</div>
</div>

     
     
     <div class="my-4">   
        <h4>Profile</h4>
        </div>

        <div class="row " style="margin-top: 2rem;">
            <div class="col-md-12"  style="text-align: center;">
    
                <h4>{{getname}}</h4>
                <p>Email : {{useremail}}<p>
                  <p> <b>Username : {{usernamecheck}}</b> <p>
                  
                  <ng-template [ngIf]="flag != 1">
                  <p>{{addressdisplay}}</p>
                  </ng-template>
    
            </div>
         
        </div>
    


        <form style="margin-top:1rem; margin-bottom: 3rem;" [formGroup]="form"  (ngSubmit)="onClickSubmit('data')">
        <div class="form-row">
          <ng-template [ngIf]="flag == 1">
            <div class="col-md-6">
              <label> <b>Username *</b> </label>
              <input type="text" class="form-control  formcontent"  style="margin: 0rem 0.2rem; margin-bottom: 1rem;" placeholder="Add new username*"  formControlName=username >
            </div>
            <div class="col-md-6">
              <label><b>Password *</b></label>
              <input type="password" class="form-control formcontent" style="margin: 0rem 0.2rem; margin-bottom: 1rem;" placeholder="Reset Password *" formControlName= password>
            </div>
          </ng-template>
            <div class="col-md-6">
              <input type="text" class="form-control  formcontent"  placeholder="First Name *" formControlName=Firstname >
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control formcontent"  placeholder="Last Name *" formControlName=lastname>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control formcontent"  placeholder="Email *"   formControlName= email>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control formcontent"   placeholder="Phone *"  formControlName= phone>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control formcontent"  placeholder="Address 1 *" formControlName= address1>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control formcontent"   placeholder="Address 2 *" formControlName= address2>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control formcontent"  placeholder="Zip"  formControlName= zip>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control formcontent" placeholder="City"  formControlName= city>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control formcontent" placeholder="State"  formControlName= state>
            </div>
            <div class="col-md-6">
              <input type="text" class="form-control formcontent" placeholder="Country *"  formControlName= country>
            </div>
            <div class="col-md-12">
              <label for="sel1">Add to the member directory?</label>  <label class="mx-2 radio-inline"> <input  type="radio" value=true name="Access" formControlName="Access" checked>Yes</label>
<label class="radio-inline">  <input type="radio" value=false name="Access" formControlName="Access"  >No</label>
            </div>
            <ng-template [ngIf]="flag == 1">
              <p style="color: rgba(248, 60, 60, 0.863);">*The username can be changed only once. <br> The password can be reset anytime using the forgot-password </p>
              </ng-template>
     
            <!-- <div class="col-md-12 accept">
              <label class="checkbox-inline"><input type="checkbox" value="true" (change)="getaccept($event.target.value)">  <a href="/privacy">Accept our Terms & Conditions</a></label>
              </div> -->
         
    
            <div class="btn-contents">
               <input type="submit" class="btn-cont" value="Save">

            </div>
          </div>
    </form>
